import { api } from "@tt-app/api";
import {
  EXAMS,
  VUEX_CONTENT_ACTION_NAMES,
  VUEX_CONTENT_MUTATION_NAMES
} from "@tt-app/constants/content";
import { getAuthInfo } from "@tt-app/utils";
const {
  BOOKMARKED_COURSES_REQUEST,
  COURSE_DETAILS_REQUEST,
  ORG_COURSES_REQUEST,
  TOGGLE_BOOKMARK,
  RECOMMENDED_COURSES_REQUEST
} = VUEX_CONTENT_ACTION_NAMES;

const {
  BOOKMARKED_COURSES,
  COURSE_DETAILS,
  ORG_COURSES,
  RECOMMENDED_COURSES,
  LOADING_BOOKMARKED_COURSES,
  LOADING_RECOMMENDED_COURSES
} = VUEX_CONTENT_MUTATION_NAMES;

const contentActions = {
  async [BOOKMARKED_COURSES_REQUEST]({ commit, rootGetters }: any) {
    commit(LOADING_BOOKMARKED_COURSES, true);
    const authInfo = await getAuthInfo(rootGetters);

    const response = await api.content.bookmarked_courses({ authInfo });

    const { data: courses } = response;
    const [cefrj, eiken, toiec] = EXAMS;

    const coursesWithLevels = courses.map(course => {
      const courseCefrj = course.cefrj;
      const cefrjLevels = cefrj.levels.filter((level: any) => {
        return level.cefrjMap.includes(courseCefrj);
      });
      const eikenLevels = eiken.levels.filter((level: any) => {
        return level.cefrjMap.includes(courseCefrj);
      });
      const toeicLevels = toiec.levels.filter((level: any) => {
        return level.cefrjMap.includes(courseCefrj);
      });
      course.levels = {
        cefrj: cefrjLevels.map((level: any) => level.display),
        eiken: eikenLevels.map((level: any) => level.display),
        toeic: toeicLevels.map((level: any) => level.display)
      };
      return course;
    });

    commit(BOOKMARKED_COURSES, { courses: coursesWithLevels });
    commit(LOADING_BOOKMARKED_COURSES, false);
  },
  async [COURSE_DETAILS_REQUEST]({ commit, rootGetters }: any, { courseUuid }: any) {
    try {
      const [cefrj, eiken, toiec] = EXAMS;

      commit(COURSE_DETAILS, { courseDetails: undefined });

      const authInfo = await getAuthInfo(rootGetters);

      const response = await api.content.course({
        authInfo,
        uuid: courseUuid
      });

      const course = response.data;

      const courseCefrj = course.cefrj;

      const cefrjLevels = cefrj.levels.filter((level: any) => {
        return level.cefrjMap.includes(courseCefrj);
      });

      const eikenLevels = eiken.levels.filter((level: any) => {
        return level.cefrjMap.includes(courseCefrj);
      });

      const toeicLevels = toiec.levels.filter((level: any) => {
        return level.cefrjMap.includes(courseCefrj);
      });

      course.levels = {
        cefrj: cefrjLevels.map(level => level.display),
        eiken: eikenLevels.map(level => level.display),
        toeic: toeicLevels.map(level => level.display)
      };

      commit(COURSE_DETAILS, { courseDetails: course });
    } catch (error) {
      console.log({ error });
    }
  },
  async [ORG_COURSES_REQUEST]({ commit, rootGetters }: any) {
    try {
      const authInfo = await getAuthInfo(rootGetters);
      const response = await api.content.organization_courses({
        authInfo
      });

      const { data: courses } = response;

      const [cefrj, eiken, toiec] = EXAMS;

      const coursesWithLevels = courses.map((course: any) => {
        const courseCefrj = course.cefrj;
        const cefrjLevels = cefrj.levels.filter((level: any) => {
          return level.cefrjMap.includes(courseCefrj);
        });
        const eikenLevels = eiken.levels.filter((level: any) => {
          return level.cefrjMap.includes(courseCefrj);
        });
        const toeicLevels = toiec.levels.filter((level: any) => {
          return level.cefrjMap.includes(courseCefrj);
        });
        course.levels = {
          cefrj: cefrjLevels.map((level: any) => level.display),
          eiken: eikenLevels.map((level: any) => level.display),
          toeic: toeicLevels.map((level: any) => level.display)
        };
        return course;
      });

      commit(`${ORG_COURSES}`, coursesWithLevels);
    } catch (error) {
      console.log(error);
    }
  },
  async [TOGGLE_BOOKMARK]({ rootState, dispatch }: any, { courseUuid }: any) {
    const {
      content: {
        bookmark: { courses }
      },
      user: {
        authentication: { token },
        selectedAlias
      }
    } = rootState;

    const alias = selectedAlias;

    const currentlyBookmarked = courses.some((course: any) => {
      return course.uuid === courseUuid;
    });

    try {
      if (currentlyBookmarked) {
        await api.content.remove_bookmark({
          courseUuid,
          headers: { Authorization: `Token ${token}`, "Lingos-Users-Alias-Uuid": alias.uuid }
        });
      } else {
        await api.content.add_bookmark({
          courseUuid,
          headers: { Authorization: `Token ${token}`, "Lingos-Users-Alias-Uuid": alias.uuid }
        });
      }
    } catch (error) {
      console.log({ error });
    } finally {
      dispatch(BOOKMARKED_COURSES_REQUEST);
    }
  },
  async [RECOMMENDED_COURSES_REQUEST]({ commit, rootGetters }: any) {
    commit(LOADING_RECOMMENDED_COURSES, true);
    const authInfo = await getAuthInfo(rootGetters);

    const response = await api.content.recommended_courses({ authInfo });

    const { data: courses } = response;
    commit(RECOMMENDED_COURSES, courses);
    commit(LOADING_RECOMMENDED_COURSES, false);
  }
};

export { contentActions };
